<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        企业自评表
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="表格列设置"
            icon="e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
            plain
          ></el-button>

          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.bookingDate">
            <el-date-picker
              v-model="slotForms.forms.selfDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              placeholder="选择年"
              @change="handleSelYear"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.appraisalName">
            <el-select
              v-model="slotForms.forms.appraisalName"
              clearable
              placeholder="自评表名称"
            >
              <el-option
                v-for="item in appraisalList"
                :key="item.appraisalName"
                :label="item.appraisalName"
                :value="item.appraisalName"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.companyAppraisalSelfStatus">
            <el-select
              v-model="slotForms.forms.companyAppraisalSelfStatus"
              clearable
              placeholder="表单状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.companyName">
            <el-input
              v-model="slotForms.forms.companyName"
              placeholder="提交企业"
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          label="序号"
          width="80"
          fixed
          type="index"
        ></el-table-column>
        <template v-for="(item, index) in localShowTableCols">
          <el-table-column
            :key="index"
            :label="item.title"
            align="center"
            :show-overflow-tooltip="true"
            v-if="item.name == 'file'"
          >
            <template slot-scope="{ row }">
              <el-button type="text" @click="downloadPdf(row)">下载</el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :show-overflow-tooltip="true"
            min-width="150"
            align="center"
            :prop="item.name"
            :label="item.title"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" align="center" label="操作" width="160">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.详情"
              :to="{
                path: '/companySelfAssessmentFromDetail',
                query: {
                  companyAppraisalSelfId: scope.row.companyAppraisalSelfId,
                  companyAppraisalSelfStatus:
                    scope.row.companyAppraisalSelfStatus,
                },
              }"
              >详情</router-link
            >&nbsp;

            <el-button
              v-if="
                operationSuper.编辑 &&
                (scope.row.companyAppraisalSelfStatus === 10 ||
                  scope.row.companyAppraisalSelfStatus === 30)
              "
              @click="handleEdit(scope.row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            &nbsp;
            <router-link
              v-if="
                operationSuper.审核 &&
                scope.row.companyAppraisalSelfStatus === 0
              "
              :to="{
                path: '/companySelfAssessmentFromAudit',
                query: {
                  companyAppraisalSelfId: scope.row.companyAppraisalSelfId,
                },
              }"
              >审核</router-link
            >&nbsp;
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
  </div>
</template>

<script>
import { getCompanyFormNameList } from "@/api/businessApplication";
import { mapActions } from "vuex";
import operationManage from "_private/mixins/operationManage";
import listInit from "@/mixins/listInit";
import moment from "moment";
export default {
  mixins: [operationManage, listInit],
  data() {
    return {
      // dataType: "object",
      isSearch: false,
      formExtend: {
        forms: {
          selfDate: moment().format("YYYY"), // 自评年份
          appraisalName: "", // 自评表名称
          companyName: "", // 提交企业
          companyAppraisalSelfStatus: "", // 自评表状态
        },
        extends: [],
      },
      statusOptions: [
        {
          value: 10,
          label: "可填写",
        },
        {
          value: 20,
          label: "不可填写",
        },
        {
          value: 0,
          label: "审核中",
        },
        {
          value: 40,
          label: "已通过",
        },
        {
          value: 30,
          label: "驳回可填写",
        },
      ],
      appraisalList: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      idList: [],
      errMess: "",
      isFirstLoad: true,
      // 请求表格数据
      tableDataUrl: "/appraisal/company/list",
      //导出URL
      exportUrl: "/appraisal/company/export?",
    };
  },

  created() {
    this.setSearchFormIsOpenAct();
    this.getFormNameByYear();
    this.initPage();
  },
  mounted() {},
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 根据申请年份查询自评表名称
    async getFormNameByYear() {
      try {
        let res = await getCompanyFormNameList({
          selfDate: this.formExtend.forms.selfDate,
        });
        if (res.code) {
          this.appraisalList = res.result;
        }
      } catch (err) {
        console.log(err);
      }
    },
    //
    handleSelYear() {
      this.getFormNameByYear();
      this.formExtend.forms.appraisalName = "";
    },
    // 点击编辑
    handleEdit({ companyAppraisalSelfId, companyAppraisalSelfStatus }) {
      this.$router.push({
        path: "/companySelfAssessmentFromEdit",
        query: {
          companyAppraisalSelfId: companyAppraisalSelfId,
          companyAppraisalSelfStatus: companyAppraisalSelfStatus,
        },
      });
    },
    // 重置
    handleResetForm() {
      this.formExtend.forms.selfDate = moment().format("YYYY"); // 自评年份
    },
    // 导出
    handleExportClick() {
      let param = "";
      param += "&selfDate=" + this.formExtend.forms.selfDate;
      param += "&appraisalName=" + this.formExtend.forms.appraisalName;
      param += "&companyName=" + this.formExtend.forms.companyName;
      param +=
        "&companyAppraisalSelfStatus=" +
        this.formExtend.forms.companyAppraisalSelfStatus;
      document.location.href = this.exportUrl + param;
    },
    // 下载
    downloadPdf({ companyAppraisalSelfId }) {
      try {
        document.location.href = `/appraisal/company/download?companyAppraisalSelfId=${companyAppraisalSelfId}`;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.mt20 {
  margin-top: 20px;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}
/deep/ .el-table__body-wrapper {
  height: calc(100% - 36px) !important;
}

/deep/ .e6-from--column-2 .vehicle_temp {
  width: 100px !important;
}
.operate-btn {
  height: 29px;
  color: #fff;
  background: #2f4ef2;
  border-color: #2f4ef2;
  &:hover {
    color: #fff;
    background: #2f4ef2;
    border-color: #2f4ef2;
  }
}
/deep/ .el-dialog {
  .el-dialog__body {
    padding: 20px;
    p {
      font-size: 16px;
    }
  }
  .el-dialog__footer {
    text-align: center;
  }
}
</style>
